import React, { useRef } from 'react';
import QRCode from 'react-qr-code';
import { Button } from 'react-bootstrap';
import { CheckCircleFill, Clipboard, Whatsapp } from 'react-bootstrap-icons';
import './CouponDisplay.scss';

interface CouponDisplayProps {
  couponCode: string;
  generatedUrl: string;
  onCopyToClipboard: () => void;
  onWhatsAppShare: () => void;
  onShowWhatsAppInput: () => void;
  showWhatsAppButton: boolean;
  clientPhone?: string;
}

const CouponDisplay: React.FC<CouponDisplayProps> = ({
  couponCode,
  generatedUrl,
  onCopyToClipboard,
  onWhatsAppShare,
  onShowWhatsAppInput,
  showWhatsAppButton,
  clientPhone
}) => {
  const couponRef = useRef<HTMLDivElement>(null);

  return (
    <div className="coupon-display" ref={couponRef}>
      <div className="success-header">
        <div className="success-icon">
          <CheckCircleFill size={48} />
        </div>
        <h5>¡Cupón generado exitosamente!</h5>
      </div>

      <div className="qr-code-container">
        <QRCode 
          value={generatedUrl} 
          size={150} 
          bgColor="transparent" 
          fgColor="#FC7556"
          level="M"
        />
      </div>
      
      <div className="coupon-info">
        <div className="coupon-code">
          <span className="code-label">Código:</span>
          <span className="code-value">{couponCode}</span>
        </div>
      </div>

      <div className="share-section">
        <div className="share-buttons">
          <Button 
            className="share-btn clipboard" 
            onClick={onCopyToClipboard}
          >
            <Clipboard size={18} />
            <span>Copiar enlace</span>
          </Button>

          {showWhatsAppButton ? (
            <Button 
              className="share-btn whatsapp" 
              onClick={onWhatsAppShare}
            >
              <Whatsapp size={18} />
              <span>Enviar por WhatsApp</span>
            </Button>
          ) : (
            <Button 
              className="share-btn whatsapp" 
              onClick={onShowWhatsAppInput}
            >
              <Whatsapp size={18} />
              <span>Enviar por WhatsApp</span>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CouponDisplay;
